import state from './state'
import * as mutations from './mutation'

let namespaced = true;

export default {
    namespaced,
    state,
    mutations
}